import { createContext } from "react";

export const WSFormFieldContext = createContext("");
